import { Typography } from '@mui/material';
import { InteractiveModal } from 'components/Modals/InteractiveModal/BaseModal';
import ExternalUserHandler from 'handlers/external.user.handler';
import { useTranslation } from 'react-i18next';

export {};

/**
 *
 * The activation modal is a modal that is used to activate an External user.
 */

interface Props {
  open: boolean;
  userId: string;
  firstName: string;
  lastName: string;
  handleAbort: () => void;
}

export const ExternalUserActivationModal = ({
  open,
  userId,
  firstName,
  lastName,
  handleAbort,
}: Props) => {
  const { t } = useTranslation();
  const userHandler = new ExternalUserHandler();
  const title = 'Confirm User Reactivation';

  return (
    <InteractiveModal
      initialState={open}
      title={title}
      handleAbort={handleAbort}
      SuccessButtonProps={{
        onClick: async () => {
          await userHandler.activateExternalUser(userId, firstName, lastName);
          handleAbort();
        },
        disabled: false,
        label: t('reactivate_user'),
      }}
      ModalContentProps={{
        gridItemProps: {
          lg: 12,
        },
      }}
    >
      <Typography key="blurb-1" variant="medium">
        {t('are_you_sure_you_want_to_reactivate')} {firstName} {lastName}?
      </Typography>
      <Typography key="blurb-2" variant="medium"></Typography>
    </InteractiveModal>
  );
};
